<script lang="ts">
    import { get } from 'svelte/store';
    import { _ } from 'svelte-i18n';

    import { Account } from './Account';
    import { api } from '../../../stores/api';
    import IconExpander from '../../shared/Icons/IconExpander.svelte';
    import InputText from '../../shared/InputText.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import LinkSmallBlack from '../../shared/LinkSmallBlack.svelte';
    import { onMount } from 'svelte';
    import TemplateErrorGroup from '../../shared/TemplateErrorGroup.svelte';
    import { AccountValidator } from './AccountValidator.js';
    import { AccountApp } from './AccountApp';
    import IconUser from '../../shared/Icons/IconUser.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import { debug } from '../../../stores/store';
    import SuccessColor from '../../shared/SuccessColor.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';
    import WarningColor from '../../shared/WarningColor.svelte';
    import SettingsRowValue from '../Settings/SettingsRowValue.svelte';
    import SettingsRowLabel from '../Settings/SettingsRowLabel.svelte';
    import Select from '../../shared/Select.svelte';
    import SettingsRow from '../Settings/SettingsRow.svelte';
    import InputNumber from '../../shared/InputNumber.svelte';
    import { AdminApi } from './AdminApi';
    import { z } from 'zod';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import AccountUserManagerRow from './AccountUserManagerRow.svelte';
    import { toPermissions } from '../../../stores/app';

    export let showHeader: boolean = true;
    export let expandedIndex: string = '';
    export let addMode: boolean = false;
    export let ap: AccountApp;
    export let account: Account;
    export let onAdd: () => void;

    let expanded: boolean = false;
    let error: string = '';
    let errorDetails: string = '';
    let loading: boolean = false;
    let validated: boolean = true; // TODO: implement validation

    // 2C4q71Yx
    // maciej.dymowski+test-create1@automapa.pl

    function toggleExpanded() {
        console.log('toggleExpanded');
        expandedIndex = expandedIndex === account.innerId ? '' : account.innerId;
        expanded = expandedIndex === account.innerId || addMode;
    }

    onMount(() => {
        console.log('AccountOne onMount');
    });

    console.log('AccountOne, account:', account);

    $: expanded = expandedIndex === account.innerId || addMode;

    $: validated = AccountValidator.validateAll(account);
</script>

{#if $debug}
    <div>
        account.get: {JSON.stringify(account.get())}
    </div>
{/if}

{#if showHeader}
    <div class="list-element vehicle-header list-element-header">
        <div class="vehicle_icon"></div>
        <div class="name">{$_('Account name')}</div>
        <div class="email">{$_('E-mail')}</div>
        <div class="expiration-date">{$_('Expiration date')}</div>
    </div>
{/if}

{#if !expanded}
    <div class="list-element vehicle-header list-element-data">
        <div
            class="vehicle_icon"
            on:click={() => {
                toggleExpanded();
            }}
        >
            <IconUser scale={0.7} />
        </div>

        <div
            class="customer-id"
            style="line-height: 14px;"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getCustomerId()}
        </div>

        <div
            class="name"
            style="line-height: 14px;"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getName()}
        </div>

        <div
            class="email"
            style="line-height: 14px;"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getEmail()}
        </div>

        <div
            class="expiration-date"
            class:extended-background={expanded}
            on:click={() => {
                toggleExpanded();
            }}
        >
            {account.getExpirationDate()}
        </div>

        <div class="is-expired" title="is account expired?">
            {#if account.isExpired() === true}
                <ErrorColor>{$_('EXPIRED')}</ErrorColor>
            {:else if account.isExpired() === false}
                <SuccessColor>{$_('ACTIVE')}</SuccessColor>
            {:else}
                <WarningColor>???</WarningColor>
            {/if}
        </div>

        <div class="expand-trigger">
            <IconExpander
                isOpen={expanded}
                on:click={() => {
                    toggleExpanded();
                }}
            />
        </div>
    </div>
{/if}

{#if expanded}
    <div class="vehicle-expanded-container">
        <TemplateErrorGroup {error} {errorDetails}>
            <div class="vehicle-header">
                <div
                    class="vehicle_icon"
                    on:click={() => {
                        toggleExpanded();
                    }}
                >
                    <IconUser scale={0.7} />
                </div>
                <div
                    class="customer-id"
                    on:click={() => {
                        toggleExpanded();
                    }}
                >
                    {#if !addMode}
                        ({account.getCustomerId()})
                    {/if}
                </div>
                <div class="name">
                    <InputText
                        value={account.getName()}
                        valid={AccountValidator.isNameValid(account) === ''}
                        style="width: 100%"
                        disabled={!addMode}
                        on:change={event => {
                            if (event?.target) {
                                account.setName(event?.target?.value || '');
                                account = account;
                                if (!addMode) {
                                    ap.save(account);
                                }
                            }
                        }}
                        on:keyup={event => {
                            account.setName(event?.target?.value || '');
                            account = account;
                        }}
                    />
                </div>
                <div class="email">
                    <InputText
                        value={account.getEmail()}
                        valid={AccountValidator.isEmailValid(account) === ''}
                        disabled={!addMode}
                        style="width: 100%"
                        on:change={event => {
                            if (event?.target) {
                                account.setEmail(event?.target?.value || '');
                                account = account;
                                if (!addMode) {
                                    ap.save(account);
                                }
                            }
                        }}
                        on:keyup={event => {
                            account.setEmail(event?.target?.value || '');
                            account = account;
                        }}
                    />
                </div>
                <div class="expiration-date">
                    <SelectDay
                        day={account.getExpirationDate()}
                        minDay={null}
                        valid={AccountValidator.isExpirationDateValid(account) === ''}
                        autoApply={true}
                        disabled={false}
                        onChange={async day => {
                            account.setExpirationDate(day);
                            account = account;
                            if (!addMode) {
                                await ap.updateExpirationDate(get(api), account).catch(err => {
                                    console.error(err);
                                    alert($_(err));
                                });
                                ap = await ap.prepareData(get(api));
                            }
                        }}
                    />
                </div>

                <div class="is-expired">
                    {#if !addMode}
                        {#if account.isExpired() === true}
                            <ErrorColor>{$_('EXPIRED')}</ErrorColor>
                        {:else if account.isExpired() === false}
                            <SuccessColor>{$_('ACTIVE')}</SuccessColor>
                        {:else}
                            <WarningColor>???</WarningColor>
                        {/if}
                    {/if}
                </div>

                <div class="expand-trigger">
                    {#if !addMode}
                        <IconExpander
                            isOpen={expanded}
                            on:click={() => {
                                toggleExpanded();
                            }}
                        />
                    {/if}
                </div>
            </div>
        </TemplateErrorGroup>

        {#if !addMode}
            <TemplateErrorGroup {error} {errorDetails}>
                <div style="padding: 10px 20px;">
                    <SettingsRow>
                        <SettingsRowLabel>
                            {$_('Max locations')}
                        </SettingsRowLabel>
                        <SettingsRowValue>
                            <InputNumber
                                style="max-width: 120px; width: 120px;"
                                value={typeof(account.getSettingsReadonly()?.max_locations) == 'number' ? account.getSettingsReadonly()?.max_locations.toString() : ''}
                                on:change={e => {
                                    if (z.coerce.number().safeParse(e.target?.value).success === false) {
                                        return;
                                    }
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        max_locations: e.target?.value ? z.coerce.number().parse(e.target?.value) : null,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel>
                            {$_('Max connections')}
                        </SettingsRowLabel>
                        <SettingsRowValue>
                            <InputNumber
                                style="max-width: 120px; width: 120px;"
                                value={typeof(account.getSettingsReadonly()?.max_connections) == 'number' ? account.getSettingsReadonly()?.max_connections.toString() : ''}
                                on:change={e => {
                                    if (z.coerce.number().safeParse(e.target?.value).success === false) {
                                        return;
                                    }
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        max_connections: e.target?.value ? z.coerce.number().parse(e.target?.value) : null,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel>
                            {$_('Max transactions per month')}
                        </SettingsRowLabel>
                        <SettingsRowValue>
                            <InputNumber
                                style="max-width: 120px; width: 120px;"
                                value={typeof(account.getSettingsReadonly()?.max_transactions_per_month) == 'number' ? account.getSettingsReadonly()?.max_transactions_per_month.toString() : ''}
                                on:change={e => {
                                    if (z.coerce.number().safeParse(e.target?.value).success === false) {
                                        return;
                                    }
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        max_transactions_per_month: e.target?.value ? z.coerce.number().parse(e.target?.value) : null,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel>
                            {$_('Max rows per file')}
                        </SettingsRowLabel>
                        <SettingsRowValue>
                            <InputNumber
                                style="max-width: 120px; width: 120px;"
                                value={account.getSettingsReadonly()?.max_rows_per_file.toString() ?? ''}
                                on:change={e => {
                                    if (z.coerce.number().safeParse(e.target?.value).success === false) {
                                        return;
                                    }
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        max_rows_per_file: z.coerce.number().parse(e.target?.value),
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel></SettingsRowLabel>
                        <SettingsRowValue>
                            <Checkbox
                                checked={account.getSettingsReadonly()?.allow_limit_exceeding}
                                label={$_('Allow limit exceeding')}
                                disabled={false}
                                onChange={value => {
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        allow_limit_exceeding: value,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel></SettingsRowLabel>
                        <SettingsRowValue>
                            <Checkbox
                                checked={account.getSettingsReadonly()?.allow_file_import}
                                label={$_('Allow file import (only for payed accounts)')}
                                disabled={false}
                                onChange={value => {
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        allow_file_import: value,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel></SettingsRowLabel>
                        <SettingsRowValue>
                            <Checkbox
                                checked={account.getSettingsReadonly()?.ext_id_must_exists_in_full_name}
                                label={$_('Ext_id must exists in full name (only for DPD)')}
                                disabled={false}
                                onChange={value => {
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        ext_id_must_exists_in_full_name: value,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <SettingsRow>
                        <SettingsRowLabel></SettingsRowLabel>
                        <SettingsRowValue>
                            <Checkbox
                                checked={account.getSettingsReadonly()?.short_name_instead_of_unique_id}
                                label={$_('Use short name instead of unique id (displaying only) (only for DPD)')}
                                disabled={false}
                                onChange={value => {
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        short_name_instead_of_unique_id: value,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                    <AccountUserManagerRow
                        webuserId={account.getWebuserId()}
                        permissions={account.getPermissions()}
                        onSave={async isUserManager =>
                            toPermissions(
                                await AdminApi.setUserManager(
                                    get(api),
                                    account.getWebuserId() ?? 0,
                                    isUserManager
                                )
                            )}
                        onSaved={permissions => {
                            account.setPermissions(permissions);
                            account = account;
                        }}
                    />
                    <SettingsRow>
                        <SettingsRowLabel>
                            {$_('Allowed area')}
                        </SettingsRowLabel>
                        <SettingsRowValue>
                            <Select
                                items={[
                                    { id: 'pl', label: 'Poland' },
                                    { id: 'eu', label: 'Europe' },
                                ]}
                                selected={account.getSettingsReadonly()?.allowed_area ?? 'pl'}
                                onChange={value => {
                                    account.setSettingsReadonly({
                                        ...account.getSettingsReadonly(),
                                        allowed_area: value,
                                    });
                                    AdminApi.updateSettingsReadonly(get(api), account.getCustomerId(), account.getSettingsReadonly());
                                    return true;
                                }}
                            />
                        </SettingsRowValue>
                    </SettingsRow>
                </div>
            </TemplateErrorGroup>
        {/if}

        {#if addMode}
            <div style="display: flex; justify-content: flex-end; align-items: flex-end; padding: 20px;">
                <div style="display: flex; align-items: center;column-gap: 30px;">
                    <span style="font-size: 14px;">
                        <LinkSmallBlack
                            text={$_('Cancel')}
                            on:click={() => {
                                addMode = false;
                            }}
                        />
                    </span>
                    <ButtonMain
                        text={$_('Add account')}
                        disabled={loading || !validated}
                        on:click={() => {
                            error = '';
                            loading = true;
                            // SettingsApi.createDemoAccount(
                            //     get(api),
                            //     account.getName(),
                            //     account.getEmail(),
                            //     account.getExpirationDate()
                            // )
                            ap.create(get(api), account)
                                .then(accountResponse => {
                                    // copy accountResponse.user_password to clipboard
                                    if (navigator.clipboard) {
                                        navigator.clipboard
                                            .writeText(accountResponse.user_password)
                                            .then(() => {
                                                console.log('Password copied to clipboard');
                                                alert(
                                                    'Account created, please write down this password (or get from clipboard): ' +
                                                        accountResponse.user_password
                                                );
                                            })
                                            .catch(err => {
                                                console.error('Could not copy text: ', err);
                                                alert('Account created, please write down this password: ' + accountResponse.user_password);
                                            });
                                    } else {
                                        console.warn('Clipboard API not available');
                                        alert('Account created, please write down this password: ' + accountResponse.user_password);
                                    }
                                    addMode = false;
                                })
                                .catch(err => {
                                    error = $_('Cannot save this account');
                                    console.warn('Cannot save this account', err);
                                    alert($_(err));
                                    errorDetails = err;
                                })
                                .finally(() => {
                                    onAdd();
                                    loading = false;
                                });
                        }}
                    />
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .vehicle-header {
        display: grid;
        grid-template-columns: 30px 60px 1fr 1fr 120px 50px 30px;
        grid-template-rows: var(--medium-row-height) max-content;
        /*background-color: #cfa516;*/
        grid-template-areas: 'vehicle_icon customer-id name email expiration-date is-expired expand-trigger';
        align-items: center;
        column-gap: 5px;
    }
    .vehicle-header .vehicle_icon {
        grid-area: vehicle_icon;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vehicle-header .name {
        grid-area: name;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
        /*overflow: hidden;*/
        /*line-height: 13px;*/
    }
    .expiration-date {
        grid-area: expiration-date;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .vehicle-header .email {
        grid-area: email;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 5px 0;
        cursor: pointer;
        line-height: 13px;
        overflow: hidden;
    }
    .vehicle-header .expand-trigger {
        grid-area: expand-trigger;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .vehicle-expanded-container {
        background-color: var(--selected-item-background);
        /*background-color: #f92672;*/
    }
    .vehicle-expanded-container .vehicle-header {
        grid-template-rows: 41px;
    }
</style>
